module.exports = __webpack_public_path__ + "static/media/GE.dddf227c.svg";